"use client";

import { useSectionNavTheme } from "@/app/hooks/useSectionNavTheme";
import { Heading2 } from "../typography";
import { useRef } from "react";
import { PinnedScrollSection } from "../shared";

export const TheResults = () => {
  const sectionRef = useRef<HTMLDivElement | null>(null);

  const achievements = [
    {
      title: "Delivers continental-scale real-time monitoring",
      description:
        "providing instant environmental insights across Australia's entire continent, replacing what previously required days of supercomputer processing and massive computational resources.",
    },
    {
      title: "Processes many terabytes of environmental data",
      description:
        "from tens of monitoring sources through automated workflows, enabling seamless data integration and real-time analysis that powers comprehensive national reporting.",
    },
    {
      title: "Enables universal data accessibility",
      description:
        "with environmental scorecards for every region in Australia, serving researchers, managers, educators, students, and citizens with intuitive interactive exploration tools.",
    },
    {
      title: "Powers Australia's premier environmental monitoring system",
      description:
        "with scalable infrastructure supporting evidence-based decision-making, policy development, and continuous evolution of environmental health assessment capabilities.",
    },
  ];

  useSectionNavTheme({
    trigger: "#ausenv-results",
    isDark: true,
    start: "center center",
    end: () => `+=${achievements.length * 500 + window.innerHeight}`,
  });

  return (
    <div
      ref={sectionRef}
      id="ausenv-results"
      className="pt-20 lg:pb-64 lg:pt-44 relative overflow-hidden"
    >
      {/* Background Blobs */}
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-20 right-10 w-96 h-96 bg-haizea-green/30 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-10 w-[500px] h-[500px] bg-haizea-blue/20 rounded-full blur-3xl" />
        <div className="absolute top-1/2 right-1/4 w-64 h-64 bg-haizea-orange/25 rounded-full blur-2xl" />
      </div>

      <div className="results-content">
        <div className="max-w-[900px] mx-auto">
          <PinnedScrollSection
            title={
              <Heading2 className="text-slate-600 dark:text-slate-100">
                <span className="text-haizea-green">
                  Australia&apos;s Environment{" "}
                </span>
                Report now:
              </Heading2>
            }
            items={achievements}
            contentClassName="lg:h-[40vh]"
            yOffset={110}
            rangeBackground="linear-gradient(90deg, var(--color-haizea-green) 0%, var(--color-haizea-blue) 50%, var(--color-haizea-orange) 100%)"
            titleClassName="font-medium"
            descriptionClassName="text-slate-600 dark:text-slate-300"
            itemClassName="text-slate-700 dark:text-slate-200 my-4"
          />
        </div>
      </div>
    </div>
  );
};
